import * as yup from 'yup';
import { isValidYupSchema, yupUtils } from '../../utils/yup/utils';
import { Campaign } from '../types/campaign';
import { ProjectErrors, ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorForCode, getProjectErrorFromRawError, isProjectError } from '../../utils/errors';
import { parseDateToStringWithFormat } from '../../utils/dateFormat';
import { format } from '../../utils/dateFormat/types';

export const MinimalCampaignSchema = yup.object().shape({
  name: yupUtils.stringRequired('Name is required'),
});

export const CampaignSchema = yup.object().shape({
  id: yupUtils.stringRequired(),
  createdAt: yupUtils.numberRequired,
  updatedAt: yupUtils.numberRequired,
  name: yupUtils.stringRequired('Name is required'),

  isDisabled: yupUtils.booleanOptionalNullable,

  branchUrl: yupUtils.stringOptionalNullable,
});

export const processCampaign = async (campaign: any): Promise<Campaign> => {
  return {
    ...campaign,
    createdAtDate: parseDateToStringWithFormat(campaign.createdAt, format.shortMonthDayYear),
    updatedAtDate: campaign?.updatedAt
      ? parseDateToStringWithFormat(campaign.updatedAt, format.shortMonthDayYear)
      : undefined,
  } as Campaign;
};

export const parseCampaign = async (campaign: any): Promise<Campaign | ProjectErrorType> => {
  try {
    if (await isValidYupSchema(CampaignSchema, campaign)) {
      return await processCampaign(campaign);
    }

    return getProjectErrorForCode(ProjectErrors.invalidCampaign);
  } catch (error) {
    console.log(`[CAMPAIGNS] ID: ${campaign?.id}. Error:`, error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const parseCampaigns = async (campaigns: any): Promise<Campaign[]> => {
  if (!(campaigns && Array.isArray(campaigns))) {
    console.log(`[CAMPAIGNS] Error: No campaigns array provided`);
    return [];
  }

  const data: Campaign[] = [];
  for (const campaign of campaigns) {
    const o = await parseCampaign(campaign);
    if (o && !isProjectError(o)) {
      data.push(o as Campaign);
    }
  }

  return data;
};
